import { render, staticRenderFns } from "./roamPathList.vue?vue&type=template&id=4f1c9f1e&scoped=true"
import script from "./roamPathList.vue?vue&type=script&lang=js"
export * from "./roamPathList.vue?vue&type=script&lang=js"
import style0 from "./roamPathList.vue?vue&type=style&index=0&id=4f1c9f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1c9f1e",
  null
  
)

export default component.exports